import { secondsToHoursMinutesSeconds } from '@/utils/seconds-to-hours-minutes-seconds';

export const fetchLocationWaitTime = async (locationType, hasWaitTime, epicDepartmentId) => {
    if (locationType !== 'urgent-care' || !hasWaitTime || !epicDepartmentId) {
        return;
    }
    try {
        const newWaitTime = await fetch(`/bin/ahs/waitTimes?departmentId=${epicDepartmentId}`)
            .then((r) => r.json())
            .then((r) => r.waitTime);

        if (isNaN(newWaitTime)) {
            return;
        }
        const normalizedWaitTime = secondsToHoursMinutesSeconds(
            parseInt(newWaitTime, 10) / 60,
            'descriptive',
            true,
        );
        return normalizedWaitTime;
    } catch (e) {
        console.error(e.message);
    }
};
